import './modal-kform-builder-macros.scss';

const stringSaveConfig
	= '// <---------------------- SAVE_CONFIG ---------------------->\n'
	+ '// DO NOT EDIT THIS BLOCK OR BELOW. The contents are auto-generated.\n'
	+ '//\n\n';

export default class ModalKformBuilderMacrosController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {any} Notification
	 * @param {any[]} components
	 * @param {string} script
	 */
	constructor(
		$translate,
		$uibModalInstance,
		FormService,
		Notification,
		components,
		script,
	) {
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.FormService = FormService;
		this.Notification = Notification;
		this.components = components;
		this.script = script;

		this.activeAccordionNew = true;

		this.defaultMacro = {
			function: 'setValueFromPath',
			source: '',
			destination: '',
			path: [],
		};

		/** @type {any} */
		this.destination = undefined;

		this.functions = [
			{
				id: 'setValueFromPath',
				name: 'Set value from path',
			},
		];

		/** @type {any[]} */
		this.macros = [];

		this.newMacro = { ...this.defaultMacro };

		this.options = {
			display: 'tree',
			mode:    'class',
		};

		/** @type {{manual: string, auto: string}} */
		this.parsedScript = {
			manual: '',
			auto: '',
		};

		/** @type {any[]} */
		this.path = [];

		/** @type {any} */
		this.source = undefined;

		this.parseScript();
	}

	addMacro() {
		this.macros.push(this.newMacro);
		this.newMacro = { ...this.defaultMacro };
		this.activeAccordionNew = false;
	}

	/**
	 * @param {number} k
	 */
	deleteMacro(k) {
		this.macros.splice(k, 1);
		this.activeAccordionNew = this.macros.length === 0;
	}

	/**
	 * @param {string} f
	 * @returns {string}
	 */
	getFunctionName(f) {
		const index = this.functions.findIndex(fu => fu.id === f);
		return index >= 0 ? this.functions[index].name : '';
	}

	parseScript() {
		[this.parsedScript.manual, this.parsedScript.auto] = this.script.split(stringSaveConfig);

		if (this.parsedScript.auto) {
			const matches = [...this.parsedScript.auto.matchAll(/^\/\*\* function=(?<function>.+) source=(?<source>.+) destination=(?<destination>.+) path=(?<path>.+) \*\/\n([\S\s]+)$/gm)];
			this.macros = matches.map(match => ({
				function:    match.groups?.function,
				destination: match.groups?.destination,
				source:      match.groups?.source,
				path:        JSON.parse(match.groups?.path ?? '[]'),
			}));
			this.activeAccordionNew = this.macros.length === 0;
		}
	}

	submit() {
		const scripts = [];
		for (const macro of this.macros) {
			// eslint-disable-next-line max-len
			scripts.push(`/** function=${macro.function} source=${macro.source} destination=${macro.destination} path=${JSON.stringify(macro.path)} */\nform.addEvent('${macro.source}', 'change', async () => form.${macro.function}('${macro.source}', '${macro.destination}', ${JSON.stringify(macro.path)}, data));\n\n`);
		}

		this.script = scripts.length > 0
			? `${this.parsedScript.manual}\n\n${stringSaveConfig}${scripts.join('\n\n')}`
			: `${this.parsedScript.manual}`;

		this.$uibModalInstance.close(this.script);
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
